import { Fragment } from "react";
import "./style.css";
import familly from "Assets/Images/About/familly.png";
import { Shop } from "react-bootstrap-icons";

const HeroImage = () => {
  return (
    <Fragment>
      <section className="all-hero-image">
        <div className="hero-image container p-0 ">
          <img src={familly} alt="" className="w-100 hero-img " />
          <div className="title-business-category d-flex justify-content-between align-items-center  border-bottom p-4 ">
            <h6 className="m-0 link-roud-map">ارتباط با داپ اَپ</h6>

            <div className="icon-part d-flex justify-content-between align-items-center">
              <Shop className="ms-1 border-start ps-2" size={25} />
              <p className="m-0 link-roud-map">پشتیبانی</p>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default HeroImage;
